import { createContext, ReactNode, useContext } from 'react';
import { Tab } from '../components/Tab';

interface TabContext {
  tabs: Tab[];
}

export const TabContext = createContext<TabContext>({} as TabContext);

export const useTabs = () => {
  const context = useContext(TabContext);
  return context;
};

interface TabsProviderProps {
  tabs: Tab[];
  children?: ReactNode;
}

export const TabsProvider = ({ children, tabs }: TabsProviderProps) => {
  return <TabContext.Provider value={{ tabs }}>{children}</TabContext.Provider>;
};
